export default __webpack_public_path__ + "static/media/mapColoringSample.7505bfb9a7671e0ee279180a79abd5bb.png";